import styled from "styled-components"

import theme from "@irati/ui/src/global/theme"
import Flex from "@irati/ui/src/Flex"
import {Body} from "@irati/ui/src/Typography"

export const WarningContainer = styled(Flex)`
  background-color: ${theme.colors.utility.highlight};
  border-radius: ${theme.border.radius.large};
`
export const LinkCard = styled(Flex)`
  height: ${theme.spacing.eight};
  margin-bottom: ${theme.spacing.three};
  background-color: ${theme.colors.utility.highlight};
  border-radius: ${theme.border.radius.medium};
  border: 1px solid ${theme.colors.utility.contrast};
`
export const StyledLink = styled(Body)`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: calc(100% - 175px);
`
